import './styles.scss'

export default function Title(props) {
    return (
        <p className='header-title'>{props.txt}</p>
    )
}